import { createContext, useContext, useState } from "react";

const SavingContext = createContext();

export const SavingProvider = ({ children }) => {
  const [isSaving, setIsSaving] = useState({
    collection:false,
    digital:false,
    conservation:false
  });
  
  return (
    <SavingContext.Provider value={{ isSaving, setIsSaving }}>
      {children}
    </SavingContext.Provider>
  );
};

export const useSaving = () => useContext(SavingContext);
